// src/pages/yachts/special-offers/CreateSpecialOfferContainer.js
import React from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';

import ManageSpecialOfferPresenter from './ManageSpecialOfferPresenter';
import buildOfferPayload from './buildOfferPayload';
import parseApiError from './parseApiError';
import {
    createSpecialOffer,
    fetchOfferYachtRates,
    fetchOfferYachtSeasons
} from './redux/_actions';

class CreateSpecialOfferContainer extends React.Component {
    state = {
        loading: true,
        submitError: null,
        conflictOfferId: null,
        warnings: []
    };

    componentDidMount() {
        const yachtId = this.props.match.params.id;
        Promise.all([
            this.props.fetchOfferYachtRates(yachtId),
            this.props.fetchOfferYachtSeasons(yachtId)
        ]).finally(() => this.setState({ loading: false }));
    }

    onSubmit = (values) => {
        const yachtId = Number(this.props.match.params.id);
        return this.props
            .createSpecialOffer(buildOfferPayload(values, yachtId))
            .then((data) => {
                if (!data || !data.id) return;
                // The offer saved either way; warnings are held on screen so the admin
                // sees them in context instead of losing them to the redirect.
                if (data.warnings && data.warnings.length) {
                    this.setState({ submitError: null, warnings: data.warnings });
                    return;
                }
                this.props.history.push(
                    `/yachts/view/charter/${yachtId}/special-offers`
                );
            })
            .catch((error) => {
                const { message, conflictOfferId, fieldErrors } = parseApiError(error);
                this.setState({ submitError: message, conflictOfferId, warnings: [] });
                // Also surfaces the message inline under the field it names.
                if (fieldErrors) throw new SubmissionError(fieldErrors);
            });
    };

    render() {
        return (
            <ManageSpecialOfferPresenter
                loading={this.state.loading}
                isEdit={false}
                user_role={this.props.user_role}
                match={this.props.match}
                history={this.props.history}
                onSubmit={this.onSubmit}
                submitError={this.state.submitError}
                conflictOfferId={this.state.conflictOfferId}
                warnings={this.state.warnings}
                warningsHref={`/yachts/view/charter/${this.props.match.params.id}/special-offers`}
                initialValues={{
                    audience: 'public',
                    is_active: true,
                    allow_partial_application: false,
                    priority: 0
                }}
                simulateOpen={false}
                onOpenSimulate={() => {}}
                onCloseSimulate={() => {}}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    user_role: state.auth.user_role
});

const mapDispatchToProps = (dispatch) => ({
    createSpecialOffer: (payload) => dispatch(createSpecialOffer(payload)),
    fetchOfferYachtRates: (id) => dispatch(fetchOfferYachtRates(id)),
    fetchOfferYachtSeasons: (id) => dispatch(fetchOfferYachtSeasons(id))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateSpecialOfferContainer);
